<template>
    <ul class="tls" aria-hidden="true">
        <li v-for="n in rows" :key="n" class="tls-row">
            <span class="tls-left">
                <span class="sk tls-cap"></span>
                <span class="sk" v-for="l in lines" :key="l" :style="{ width: lineWidths[(l - 1) % lineWidths.length] }"></span>
            </span>

            <!-- The payout lists carry a proof thumbnail; transactions do not. -->
            <span v-if="thumb" class="sk tls-thumb"></span>

            <span class="tls-right">
                <span class="sk tls-amount"></span>
                <span class="sk tls-pill"></span>
            </span>
        </li>
    </ul>
</template>

<script>
/* The loading state for the three trade lists.
 *
 * Transactions, payout and internal payout all render the same card — a block
 * of detail on the left, an amount and a status pill on the right — so they
 * share one skeleton instead of the full-screen dot overlay, which dimmed the
 * whole screen and told the reader nothing about what was coming.
 */
import '@/assets/css/skeleton.css';

export default {
    name: 'TradeListSkeleton',

    props: {
        rows: { type: Number, default: 5 },
        // Detail lines per card: transactions show five, payout three.
        lines: { type: Number, default: 4 },
        thumb: { type: Boolean, default: false },
    },

    data() {
        return {
            // Uneven widths so the block reads as text, not as bars.
            lineWidths: ['74%', '58%', '66%', '48%', '70%'],
        };
    },
};
</script>

<style scoped>
.tls {
    margin: 0;
    padding: 0;
    list-style: none;
}

.tls-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 8px;
    padding: 14px 12px;
    border-radius: 10px;
    background: #F7F8FA;
}

.tls-row:last-child {
    margin-bottom: 0;
}

.tls-left {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.tls-cap {
    width: 40%;
    height: 10px;
}

.tls-left .sk:not(.tls-cap) {
    height: 12px;
}

/* Matches .screenshotView-box so the row does not resize when the real
   thumbnail takes its place. */
.tls-thumb {
    flex: 0 0 47px;
    width: 47px;
    height: 78px;
    border-radius: 4px;
}

.tls-right {
    flex: 0 0 78px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    padding-top: 2px;
}

.tls-amount {
    width: 100%;
    height: 15px;
}

.tls-pill {
    width: 72%;
    height: 22px;
    border-radius: 999px;
}
</style>
